/** @format */

import React from 'react';
import {
    DESIGN_UPLOAD_MIMETYPES,
    REGEX_DESIGN_FILENAME,
    VARIABLE_DATA_MIMETYPES
} from 'frontier-constants';
import {QuoteContext} from 'frontier-quoter';
import SuperAgent from 'superagent';
import update from 'immutability-helper';
import {fileStackClient} from 'frontier/utilities/uploading_tools';

/**
 * HOC component to handle uploads on the new custom die slide
 * Will pick up and handle both file drops and uploads
 * @param ContainedWithDropUpload
 * @returns {{}}
 * @constructor
 */
export default ComponentContainer => {
    return class extends React.Component {
        static contextType = QuoteContext;
        constructor(props) {
            super(props);

            this.state = {
                isPreviewModalActive: false,
                orderUploads: []
            };
        }

        async componentDidMount() {
            if (this.context.order?.id) {
                const {
                    body: {orderUploads}
                } = await SuperAgent.get(
                    '/orders/quote-uploads/' + this.context.order.id + '/' + this.props.uploadType
                ).set('Accept', 'application/json');

                this.setState({
                    orderUploads
                });
            }
        }

        handleDelete = async (fileId, filestackId) => {
            this.setState(state => {
                const orderUploadIndex = state.orderUploads.findIndex(
                    orderUpload => orderUpload.id === fileId
                );

                return update(state, {orderUploads: {$splice: [[orderUploadIndex, 1]]}});
            });

            try {
                const client = fileStackClient(['read', 'remove']);
                client.remove(filestackId);
            } catch (e) {}

            this.context.handleUpdate({});
        };

        handleUploadComplete = fileEntity => {
            this.setState(
                state => update(state, {orderUploads: {$push: [fileEntity]}}),
                this.context.handleUpdate({})
            );
        };

        render() {
            const props = {...this.props};

            props.convertFiles = false;
            props.onUploadComplete = this.handleUploadComplete;

            props.createFileEntity = uploadedFile => {
                return {
                    order_id: this.context.order.id,
                    s3key: uploadedFile.key, // The original file uploaded
                    filename: uploadedFile.filename.replace(REGEX_DESIGN_FILENAME, ''),
                    size: uploadedFile.size,
                    mimetype: uploadedFile.mimetype,
                    filepicker_id: uploadedFile.handle,
                    filepicker_url: uploadedFile.url,
                    type: props.uploadType
                };
            };

            props.pickOptions = {
                accept: {$set: DESIGN_UPLOAD_MIMETYPES},
                maxFiles: {$set: 1}
            };

            props.saveFileEndpoint = '/orders/quote-add-order-upload/' + this.context.order.id;

            props.onDelete = this.handleDelete;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
};
